import { ContentPasteGo as CopyIcon, Edit as EditIcon } from "@mui/icons-material";
import { Button, Card, CardContent, CardHeader, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useAlerts, useDialog } from "../../../providers";
import { EditEventSeriesDialog } from "../dialogs/event-series-dialog";
import { useEventSeriesForCurrentBusiness } from "../hooks/use-event-series-by-business-id";

export const EventSeriesList = () => {
  const { eventSeries } = useEventSeriesForCurrentBusiness();
  const { open: openDialog } = useDialog();
  const { showSuccess } = useAlerts();

  const handleAdd = () => {
    openDialog({
      component: EditEventSeriesDialog,
    });
  };

  const handleEdit = (eventSeries: any) => {
    openDialog({
      component: EditEventSeriesDialog,
      props: { existing: eventSeries },
    });
  };

  const handleCopy = (id: number) =>
    navigator?.clipboard?.writeText(`${window.location.origin}/events/${id}`)?.then(() => {
      showSuccess("Event Series link copied");
    });

  return (
    <Card elevation={0}>
      <CardHeader
        title="Event Series"
        subheader="Group events together and create a public sharing link"
        action={
          <Button variant="outlined" color="primary" onClick={handleAdd}>
            Add
          </Button>
        }
      />
      <CardContent>
        <List>
          {eventSeries?.length === 0 && (
            <ListItem>
              <ListItemText primary="No event series found" />
            </ListItem>
          )}
          {eventSeries.map((eventSeries: any) => (
            <ListItem
              key={eventSeries.id}
              sx={{ borderBottom: "1px solid #f0f0f0" }}
              secondaryAction={
                <>
                  <IconButton edge="end" sx={{ mx: 1 }} aria-label="edit" onClick={() => handleEdit(eventSeries)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton edge="end" aria-label="copy" onClick={() => handleCopy(eventSeries.id)}>
                    <CopyIcon />
                  </IconButton>
                </>
              }
            >
              <ListItemText primary={eventSeries.name} secondary={eventSeries.isActive ? "Active" : "Disabled"} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
